import Loading from "../../../Layouts/Loading";
import { useGetQuestionQuery } from "../../../Redux/Apis/examApi";
import { KeyboardEvent, useEffect, useMemo, useState } from "react";
import TextAreaControls from "../../../Components/TextAreaControls";
import { safeParseHtml } from "../../../utils/safeParseHtml";

const stripAnswerText = (value: unknown) => {
    if (typeof value !== "string") return ""
    return value
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/\s+/g, " ")
        .trim()
}

function Question({examId,qstId,userExam,setAnswer,resetKey,setPin,readOnly = false,answerMode = 'user',detail,setDetail}:any) {
    // const { data,isLoading,isSuccess } = useGetQuestionQuery({examId,qstId,resetKey},{ refetchOnMountOrArgChange: true })
    const { data,isLoading,isSuccess } = useGetQuestionQuery({examId,qstId,userExam,resetKey})
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        event.key === "/" && event.preventDefault()
    }
    const [isClicked,setClick] = useState(true)
    const [myAnswer, setMyAnswer] = useState<string>("")

    useEffect(() => {
        if (data && !readOnly) {
            if (setAnswer) {
                setAnswer({
                    answer: data?.UserAnswer?.answer ? data.UserAnswer.answer : "",
                    "user_exam_id": userExam,
                    "question_id": data.id
                })
            }
            if (setPin) {
                setPin({
                    status: data.pined ? "CHECK" : "DELETE",
                    "user_exam_id": userExam,
                    "question_id": data.id
                })
            }
        }
    }, [setAnswer, userExam, data, setPin, readOnly])

    useEffect(() => {
        if (!readOnly || !data) return;
        if (answerMode === 'user') {
            if (data.UserAnswer && data.UserAnswer.answer) {
                setMyAnswer(data.UserAnswer.answer)
            } else {
                setMyAnswer("")
            }
        } else {
            if (data.answersheet) {
                setMyAnswer(data.answersheet)
            } else {
                setMyAnswer("")
            }
        }
    }, [answerMode, data, resetKey, readOnly])
    const showInlineLayout = useMemo(() => {
        if (!data || data.question_extra) return false
        if (data.type !== "ONECHOICE" && data.type !== "TWOCHOICE") return false

        const answers = data.answers?.R1
        if (!answers) return false

        const allValues = Object.values(answers).filter(Boolean)
        if (!allValues.length) return false

        return allValues.every((answer) => stripAnswerText(answer).length <= 10)
    }, [data])

    if(isLoading)
        return <Loading/>

    else if(isSuccess && data) {
        const isReviewMode = !!readOnly;
        const rawAnswer = isReviewMode ? (myAnswer || "") : (data?.UserAnswer?.answer || "");

        switch (data.type) {
            case "ONESPACE":
                return ( 
                    <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                        <p className="py-2 px-0 bg-secondary-subtle mb-auto mt-0">Select one entry for the blank. Fill the blank in the way that best completes the text.</p>
                        <div className="p-2">{safeParseHtml(data.question)}</div>
                        <div className="p-2 w-50 mx-auto mt-4">
                            <form className="btn-group-vertical" role="group" aria-label="answers buttons">
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="vbtn-radio"
                                    key={rawAnswer ? 'loaded_answer_ONE_1' : 'notLoadedYet_answer_ONE_1'}
                                    id="answer_ONE_1"
                                    defaultChecked={rawAnswer === "A"}
                                    autoComplete="off"
                                    disabled={isReviewMode}
                                    onClick={!isReviewMode && setAnswer ? () => setAnswer((prev: any) => ({...prev, "answer":"A"})) : undefined}
                                />
                                <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer_ONE_1"><span>{data.answers?.R1?.A}</span></label>

                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="vbtn-radio"
                                    key={rawAnswer ? 'loaded_answer_ONE_2' : 'notLoadedYet_answer_ONE_2'}
                                    id="answer_ONE_2"
                                    defaultChecked={rawAnswer === "B"}
                                    autoComplete="off"
                                    disabled={isReviewMode}
                                    onClick={!isReviewMode && setAnswer ? () => setAnswer((prev: any) => ({...prev, "answer":"B"})) : undefined}
                                />
                                <label className={`btn btn-outline-secondary px-5 label-selectable`} htmlFor="answer_ONE_2"><span>{data.answers?.R1?.B}</span></label>

                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="vbtn-radio"
                                    key={rawAnswer ? 'loaded_answer_ONE_3' : 'notLoadedYet_answer_ONE_3'}
                                    id="answer_ONE_3"
                                    defaultChecked={rawAnswer === "C"}
                                    autoComplete="off"
                                    disabled={isReviewMode}
                                    onClick={!isReviewMode && setAnswer ? () => setAnswer((prev: any) => ({...prev, "answer":"C"})) : undefined}
                                />
                                <label className={`btn btn-outline-secondary px-5 label-selectable`} htmlFor="answer_ONE_3"><span>{data.answers?.R1?.C}</span></label>

                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="vbtn-radio"
                                    key={rawAnswer ? 'loaded_answer_ONE_4' : 'notLoadedYet_answer_ONE_4'}
                                    id="answer_ONE_4"
                                    defaultChecked={rawAnswer === "D"}
                                    autoComplete="off"
                                    disabled={isReviewMode}
                                    onClick={!isReviewMode && setAnswer ? () => setAnswer((prev: any) => ({...prev, "answer":"D"})) : undefined}
                                />
                                <label className={`btn btn-outline-secondary px-5 label-selectable`} htmlFor="answer_ONE_4"><span>{data.answers?.R1?.D}</span></label>

                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="vbtn-radio"
                                    key={rawAnswer ? 'loaded_answer_ONE_5' : 'notLoadedYet_answer_ONE_5'}
                                    id="answer_ONE_5"
                                    defaultChecked={rawAnswer === "E"}
                                    autoComplete="off"
                                    disabled={isReviewMode}
                                    onClick={!isReviewMode && setAnswer ? () => setAnswer((prev: any) => ({...prev, "answer":"E"})) : undefined}
                                />
                                <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer_ONE_5"><span>{data.answers?.R1?.E}</span></label>
                            </form>
                        </div>
                        <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one answer choice.</p>
                    </div>
                );

            case "TWOSPACE":
                    return ( 
                        <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                            <p className="py-2 px-4 bg-secondary-subtle mb-auto mt-0 text-end">For each blank select one entry from the corresponding column of choices. Fill all blanks in the way that best completes the text.</p>
                            <div className="p-2">{safeParseHtml(data.question)}</div>
                            <div className="p-2 w-100 mx-auto mt-4">
                                <form className="btn-group-vertical ms-2" role="group" aria-label="answers 1 buttons">
                                    <p className="mx-auto mb-2 fw-light">Blank (i)</p>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="answer1"
                                        key={rawAnswer ? 'loaded_answer1_TWO_A' : 'notLoadedYet_answer1_TWO_A'}
                                        id="answer1_TWO_A"
                                        defaultChecked={rawAnswer.split(',')[0] === "A"}
                                        autoComplete="off"
                                        disabled={isReviewMode}
                                        onClick={
                                            !isReviewMode && setAnswer
                                                ? () =>
                                                      setAnswer((prev: any) => ({
                                                          ...prev,
                                                          answer:
                                                              "A" +
                                                              (prev.answer.split(',')[1]
                                                                  ? "," + prev.answer.split(',')[1]
                                                                  : ""),
                                                      }))
                                                : undefined
                                        }
                                    />
                                    <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer1_TWO_A"><span>{data.answers?.R1?.A}</span></label>
    
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="answer1"
                                        key={rawAnswer ? 'loaded_answer1_TWO_B' : 'notLoadedYet_answer1_TWO_B'}
                                        id="answer1_TWO_B"
                                        defaultChecked={rawAnswer.split(',')[0] === "B"}
                                        autoComplete="off"
                                        disabled={isReviewMode}
                                        onClick={
                                            !isReviewMode && setAnswer
                                                ? () =>
                                                      setAnswer((prev: any) => ({
                                                          ...prev,
                                                          answer:
                                                              "B" +
                                                              (prev.answer.split(',')[1]
                                                                  ? "," + prev.answer.split(',')[1]
                                                                  : ""),
                                                      }))
                                                : undefined
                                        }
                                    />
                                    <label className={`btn btn-outline-secondary px-5 label-selectable`} htmlFor="answer1_TWO_B"><span>{data.answers?.R1?.B}</span></label>
    
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="answer1"
                                        key={rawAnswer ? 'loaded_answer1_TWO_C' : 'notLoadedYet_answer1_TWO_C'}
                                        id="answer1_TWO_C"
                                        defaultChecked={rawAnswer.split(',')[0] === "C"}
                                        autoComplete="off"
                                        disabled={isReviewMode}
                                        onClick={
                                            !isReviewMode && setAnswer
                                                ? () =>
                                                      setAnswer((prev: any) => ({
                                                          ...prev,
                                                          answer:
                                                              "C" +
                                                              (prev.answer.split(',')[1]
                                                                  ? "," + prev.answer.split(',')[1]
                                                                  : ""),
                                                      }))
                                                : undefined
                                        }
                                    />
                                    <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer1_TWO_C"><span>{data.answers?.R1?.C}</span></label>
                                </form>
                                <form className="btn-group-vertical" role="group" aria-label="answers 2 buttons">
                                    <p className="mx-auto mb-2 fw-light">Blank (ii)</p>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="answer2"
                                        key={rawAnswer ? 'loaded_answer2_TWO_A' : 'notLoadedYet_answer2_TWO_A'}
                                        id="answer2_TWO_A"
                                        defaultChecked={rawAnswer.split(',')[1] === "D"}
                                        autoComplete="off"
                                        disabled={isReviewMode}
                                        onClick={
                                            !isReviewMode && setAnswer
                                                ? () =>
                                                      setAnswer((prev: any) => ({
                                                          ...prev,
                                                          answer:
                                                              (prev.answer.split(',')[0]
                                                                  ? prev.answer.split(',')[0] + ","
                                                                  : ",") + "D",
                                                      }))
                                                : undefined
                                        }
                                    />
                                    <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer2_TWO_A"><span>{data.answers?.R2?.A}</span></label>
    
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="answer2"
                                        key={rawAnswer ? 'loaded_answer2_TWO_B' : 'notLoadedYet_answer2_TWO_B'}
                                        id="answer2_TWO_B"
                                        defaultChecked={rawAnswer.split(',')[1] === "E"}
                                        autoComplete="off"
                                        disabled={isReviewMode}
                                        onClick={
                                            !isReviewMode && setAnswer
                                                ? () =>
                                                      setAnswer((prev: any) => ({
                                                          ...prev,
                                                          answer:
                                                              (prev.answer.split(',')[0]
                                                                  ? prev.answer.split(',')[0] + ","
                                                                  : ",") + "E",
                                                      }))
                                                : undefined
                                        }
                                    />
                                    <label className={`btn btn-outline-secondary px-5 label-selectable`} htmlFor="answer2_TWO_B"><span>{data.answers?.R2?.B}</span></label>
    
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="answer2"
                                        key={rawAnswer ? 'loaded_answer2_TWO_C' : 'notLoadedYet_answer2_TWO_C'}
                                        id="answer2_TWO_C"
                                        defaultChecked={rawAnswer.split(',')[1] === "F"}
                                        autoComplete="off"
                                        disabled={isReviewMode}
                                        onClick={
                                            !isReviewMode && setAnswer
                                                ? () =>
                                                      setAnswer((prev: any) => ({
                                                          ...prev,
                                                          answer:
                                                              (prev.answer.split(',')[0]
                                                                  ? prev.answer.split(',')[0] + ","
                                                                  : ",") + "F",
                                                      }))
                                                : undefined
                                        }
                                    />
                                    <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer2_TWO_C"><span>{data.answers?.R2?.C}</span></label>
                                </form>
                            </div>
                            <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one entry from each column.</p>
                        </div>
                    );

                    case "THREESPACE":
                        return ( 
                            <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                                <p className="py-2 px-4 bg-secondary-subtle mb-auto mt-0 text-end">For each blank select one entry from the corresponding column of choices. Fill all blanks in the way that best completes the text.</p>
                                <div className="p-2">{safeParseHtml(data.question)}</div>
                                <div className="p-2 w-100 mx-auto mt-4">
                                    <form className="btn-group-vertical ms-2 mb-2" role="group" aria-label="answers 1 buttons">
                                        <p className="mx-auto mb-1 fw-light">Blank (i)</p>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer1"
                                            key={rawAnswer ? 'loaded_answer1_THREE_A' : 'notLoadedYet_answer1_THREE_A'}
                                            id="answer1_THREE_A"
                                            defaultChecked={rawAnswer.split(',')[0] === "A"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  "A" +
                                                                  (prev.answer.split(',')[1]
                                                                      ? "," + prev.answer.split(',')[1]
                                                                      : "") +
                                                                  (prev.answer.split(',')[2]
                                                                      ? "," + prev.answer.split(',')[2]
                                                                      : ""),
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer1_THREE_A"><span>{data.answers?.R1?.A}</span></label>
        
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer1"
                                            key={rawAnswer ? 'loaded_answer1_THREE_B' : 'notLoadedYet_answer1_THREE_B'}
                                            id="answer1_THREE_B"
                                            defaultChecked={rawAnswer.split(',')[0] === "B"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  "B" +
                                                                  (prev.answer.split(',')[1]
                                                                      ? "," + prev.answer.split(',')[1]
                                                                      : "") +
                                                                  (prev.answer.split(',')[2]
                                                                      ? "," + prev.answer.split(',')[2]
                                                                      : ""),
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer1_THREE_B"><span>{data.answers?.R1?.B}</span></label>
        
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer1"
                                            key={rawAnswer ? 'loaded_answer1_THREE_C' : 'notLoadedYet_answer1_THREE_C'}
                                            id="answer1_THREE_C"
                                            defaultChecked={rawAnswer.split(',')[0] === "C"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  "C" +
                                                                  (prev.answer.split(',')[1]
                                                                      ? "," + prev.answer.split(',')[1]
                                                                      : "") +
                                                                  (prev.answer.split(',')[2]
                                                                      ? "," + prev.answer.split(',')[2]
                                                                      : ""),
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer1_THREE_C"><span>{data.answers?.R1?.C}</span></label>
                                    </form>
                                    <form className="btn-group-vertical ms-2 mb-2" role="group" aria-label="answers 2 buttons">
                                        <p className="mx-auto mb-1 fw-light">Blank (ii)</p>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer2"
                                            key={rawAnswer ? 'loaded_answer2_THREE_A' : 'notLoadedYet_answer2_THREE_A'}
                                            id="answer2_THREE_A"
                                            defaultChecked={rawAnswer.split(',')[1] === "D"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  (prev.answer.split(',')[0]
                                                                      ? prev.answer.split(',')[0] + ","
                                                                      : ",") +
                                                                  "D" +
                                                                  (prev.answer.split(',')[2]
                                                                      ? "," + prev.answer.split(',')[2]
                                                                      : ""),
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer2_THREE_A"><span>{data.answers?.R2?.A}</span></label>
        
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer2"
                                            key={rawAnswer ? 'loaded_answer2_THREE_B' : 'notLoadedYet_answer2_THREE_B'}
                                            id="answer2_THREE_B"
                                            defaultChecked={rawAnswer.split(',')[1] === "E"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  (prev.answer.split(',')[0]
                                                                      ? prev.answer.split(',')[0] + ","
                                                                      : ",") +
                                                                  "E" +
                                                                  (prev.answer.split(',')[2]
                                                                      ? "," + prev.answer.split(',')[2]
                                                                      : ""),
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer2_THREE_B"><span>{data.answers?.R2?.B}</span></label>
        
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer2"
                                            key={rawAnswer ? 'loaded_answer2_THREE_C' : 'notLoadedYet_answer2_THREE_C'}
                                            id="answer2_THREE_C"
                                            defaultChecked={rawAnswer.split(',')[1] === "F"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  (prev.answer.split(',')[0]
                                                                      ? prev.answer.split(',')[0] + ","
                                                                      : ",") +
                                                                  "F" +
                                                                  (prev.answer.split(',')[2]
                                                                      ? "," + prev.answer.split(',')[2]
                                                                      : ""),
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer2_THREE_C"><span>{data.answers?.R2?.C}</span></label>
                                    </form>
                                    <form className="btn-group-vertical mb-2" role="group" aria-label="answers 3 buttons">
                                        <p className="mx-auto mb-1 fw-light">Blank (iii)</p>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer3"
                                            key={rawAnswer ? 'loaded_answer3_THREE_A' : 'notLoadedYet_answer3_THREE_A'}
                                            id="answer3_THREE_A"
                                            defaultChecked={rawAnswer.split(',')[2] === "G"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  (prev.answer.split(',')[0]
                                                                      ? prev.answer.split(',')[0] + ","
                                                                      : ",") +
                                                                  (prev.answer.split(',')[1]
                                                                      ? prev.answer.split(',')[1] + ","
                                                                      : ",") +
                                                                  "G",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer3_THREE_A"><span>{data.answers?.R3?.A}</span></label>
        
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer3"
                                            key={rawAnswer ? 'loaded_answer3_THREE_B' : 'notLoadedYet_answer3_THREE_B'}
                                            id="answer3_THREE_B"
                                            defaultChecked={rawAnswer.split(',')[2] === "H"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  (prev.answer.split(',')[0]
                                                                      ? prev.answer.split(',')[0] + ","
                                                                      : ",") +
                                                                  (prev.answer.split(',')[1]
                                                                      ? prev.answer.split(',')[1] + ","
                                                                      : ",") +
                                                                  "H",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer3_THREE_B"><span>{data.answers?.R3?.B}</span></label>
        
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="answer3"
                                            key={rawAnswer ? 'loaded_answer3_THREE_C' : 'notLoadedYet_answer3_THREE_C'}
                                            id="answer3_THREE_C"
                                            defaultChecked={rawAnswer.split(',')[2] === "I"}
                                            autoComplete="off"
                                            disabled={isReviewMode}
                                            onClick={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer:
                                                                  (prev.answer.split(',')[0]
                                                                      ? prev.answer.split(',')[0] + ","
                                                                      : ",") +
                                                                  (prev.answer.split(',')[1]
                                                                      ? prev.answer.split(',')[1] + ","
                                                                      : ",") +
                                                                  "I",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label className={`btn btn-outline-secondary rounded-0 px-5 label-selectable`} htmlFor="answer3_THREE_C"><span>{data.answers?.R3?.C}</span></label>
                                    </form>
                                </div>
                                <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one entry from each column.</p>
                            </div>
                        );

                    case "ONECHOICE":
                        return ( 
                            data.question_extra ?
                            <div className="row m-0 p-0" style={{minHeight:"80vh"}}>
                                <div className="col-lg-6 col-xs-12 border border-1 border-secondary p-0">
                                    <div className="text-end overflow-y-auto p-0 " style={{maxHeight:"80vh"}}>
                                        {data.question_blue && 
                                            <p className="w-100 m-0 p-0 pt-1 small fw-lighter" style={{backgroundColor: "darkblue",color:"#dededeff"}}>{safeParseHtml(data.question_blue)}</p>
                                        }
                                        <div className="p-4">
                                        {safeParseHtml(data.question)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xs-12 border border-1 border-secondary p-2">
                                    <div className="d-flex align-items-middle flex-column mx-auto my-2 p-0" style={{minHeight:"78vh"}}>
                                        <div className="p-2 text-end">{data.question_extra && safeParseHtml(data.question_extra)}</div>
                                        <form className="p-2 text-end me-3">
                                            {data.answers.R1 && Object.entries(data.answers.R1).map(([key, value]:any, index) => 
                                                value && <div className="form-check form-check-reverse mb-4" key={index}>
                                                    <input
                                                        className="form-check-input gre-radio"
                                                        name="ONECHOICE_answer"
                                                        key={rawAnswer ? `loaded_radio_1_${key}` : `notLoadedYet_radio_1_${key}`}
                                                        defaultChecked={rawAnswer === key}
                                                        type="radio"
                                                        id={`radio_1_${key}`}
                                                        disabled={isReviewMode}
                                                        onChange={
                                                            !isReviewMode && setAnswer
                                                                ? () =>
                                                                      setAnswer((prev: any) => ({
                                                                          ...prev,
                                                                          answer: key,
                                                                      }))
                                                                : undefined
                                                        }
                                                    />
                                                    <label  className={`form-check-label`} htmlFor={`radio_1_${key}`}>{safeParseHtml(value)}</label>
                                                </div>
                                            )}
                                        </form>
                                        <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one answer choice.</p>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                                <p className="py-2 px-0 bg-white mb-auto mt-0"></p>
                                <div className="p-2">{safeParseHtml(data.question)}</div>
                                <form className="p-2 d-flex justify-content-center align-items-center">
                                    <div className={`checkbox-container ${showInlineLayout ? 'checkbox-inline' : 'checkbox-stacked'}`}>
                                    {data.answers.R1 && Object.entries(data.answers.R1).map(([key, value]:any) => 
                                        value && <div
                                            className={`choice-item form-check ${showInlineLayout ? 'choice-item-inline form-check-inline' : 'choice-item-stacked'}`}
                                            key={key}
                                        >
                                            <input
                                                className="form-check-input ms-0 gre-radio"
                                                name="ONECHOICE_answer"
                                                key={rawAnswer ? `loaded_radio_2_${key}` : `notLoadedYet_radio_2_${key}`}
                                                defaultChecked={rawAnswer === key}
                                                type="radio"
                                                id={`radio_2_${key}`}
                                                disabled={isReviewMode}
                                                onChange={
                                                    !isReviewMode && setAnswer
                                                        ? () =>
                                                              setAnswer((prev: any) => ({
                                                                  ...prev,
                                                                  answer: key,
                                                              }))
                                                        : undefined
                                                }
                                            />
                                            <label  className={`form-check-label d-inline-flex align-items-center px-2`} htmlFor={`radio_2_${key}`}>{safeParseHtml(value)}</label>
                                        </div>
                                    )}
                                    </div>
                                </form>
                                <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one answer choice.</p>
                            </div>
                        );


                    case "INTEXT":
                        return ( 
                            <div className="row m-0 p-0" style={{minHeight:"80vh"}}>
                                <div className="col-lg-6 col-xs-12 border border-1 border-secondary p-0">
                                    <div className="p-0 text-end overflow-y-auto" style={{maxHeight:"80vh"}}>
                                        {data.question_blue && 
                                            <p className="w-100 m-0 p-0 pt-1 small fw-lighter" style={{backgroundColor: "darkblue",color:"#dededeff"}}>{safeParseHtml(data.question_blue)}</p>
                                        }
                                        <form className="text-end p-3">
                                            {data.answers.R1 && Object.entries(data.answers.R1).map(([key, value]:any, index) => 
                                                value && <p
                                                    className={`d-inline user-select-all ${rawAnswer === key && isClicked ? "bg-dark text-light" : ""}`}
                                                    key={index}
                                                    style={{lineHeight:"1.6px",cursor: isReviewMode ? "default" : "pointer"}}
                                                    onClick={
                                                        !isReviewMode && setAnswer
                                                            ? () => {
                                                                setAnswer((prev: any) => ({...prev, "answer": key}));
                                                                setClick(false)
                                                            }
                                                            : undefined
                                                    }
                                                >
                                                    {safeParseHtml(value)}{" "}
                                                </p>
                                            )}
                                        </form>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xs-12 border border-1 border-secondary p-2">
                                    <div className="d-flex align-items-middle flex-column mx-auto my-2 p-0" style={{minHeight:"78vh"}}>
                                        <div className="p-2 text-end user-select-auto">{data.question_extra && safeParseHtml(data.question_extra)}</div>
                                        <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select a sentence in the passage</p>
                                    </div>
                                </div>
                            </div>
                        );

                    case "TWOCHOICE":
                        return ( 
                            data.question_extra ?
                            <div className="row m-0 p-0" style={{minHeight:"80vh"}}>
                                <div className="col-lg-6 col-xs-12 border border-1 border-secondary p-0">
                                    <div className="p-0 text-end overflow-y-auto" style={{maxHeight:"80vh"}}>
                                        {data.question_blue && 
                                            <p className="w-100 m-0 p-0 pt-1 small fw-lighter" style={{backgroundColor: "darkblue",color:"#dededeff"}}>{safeParseHtml(data.question_blue)}</p>
                                        }
                                        <div className="p-3">
                                            {safeParseHtml(data.question)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-xs-12 border border-1 border-secondary p-2">
                                    <div className="d-flex align-items-middle flex-column mx-auto my-2 p-0" style={{minHeight:"78vh"}}>
                                        <p className="py-2 px-3 bg-secondary-subtle mt-0 text-end">Consider each of the choices separately and select all that apply.</p>
                                        <div className="p-2 text-end">{safeParseHtml(data.question_extra)}</div>
                                        <form className="p-2 text-end mt-4">
                                            {data.answers.R1 && Object.entries(data.answers.R1).map(([key, value]:any, index) => 
                                                value && <div className="form-check form-check-reverse mb-4" key={`check_TWO_1_${index}`}>
                                                <input
                                                    className={`form-check-input gre-checkbox`}
                                                        key={rawAnswer ? `loaded_check_TWO_1_${key}` : `notLoadedYet_check_TWO_1_${key}`}
                                                        defaultChecked={rawAnswer.includes(key)}
                                                        name={key}
                                                        type="checkbox"
                                                        id={`check_TWO_1_${key}`}
                                                        disabled={isReviewMode}
                                                        onChange={
                                                            !isReviewMode && setAnswer
                                                                ? (e) =>
                                                                      setAnswer((prev: any) => ({
                                                                          ...prev,
                                                                          answer: e.target.checked
                                                                              ? prev.answer +
                                                                                (prev.answer.includes(key) ? "" : key)
                                                                              : prev.answer.replace(key, ""),
                                                                      }))
                                                                : undefined
                                                        }
                                                    />
                                                    <label className={`form-check-label px-2`} htmlFor={`check_TWO_1_${key}`}>{safeParseHtml(value)}</label>
                                                </div>
                                            )}
                                        </form>
                                        <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one or more answer choices.</p>
                                    </div>
                                </div>
                            </div>
                            :
                            data.section === 'VERBAL' ?
                            <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                                <p className="py-2 px-4 bg-secondary-subtle mb-auto mt-0 text-end">Select the two answer choices that, when used to complete the sentence, fit the meaning of the sentence as a whole and produce completed sentences that are alike in meaning.</p>
                                <div className="p-2 mb-4">{safeParseHtml(data.question)}</div>
                                <form className="d-flex justify-content-center align-items-center">
                                    <div className={`checkbox-container ${showInlineLayout ? 'checkbox-stacked' : 'checkbox-stacked'}`}>
                                    {data.answers.R1 && Object.entries(data.answers.R1).map(([key, value]:any) => 
                                        value && <div
                                            className={`choice-item form-check ${showInlineLayout ? 'choice-item-stacked mb-2' : 'choice-item-stacked mb-2'}`}
                                            key={key}
                                        >
                                            <input
                                                className="form-check-input align-middle ms-0 gre-checkbox"
                                                name={key}
                                                key={rawAnswer ? `loaded_check_TWO_2_${key}` : `notLoadedYet_check_TWO_2_${key}`}
                                                defaultChecked={rawAnswer.includes(key)}
                                                type="checkbox"
                                                id={`check_TWO_2_${key}`}
                                                disabled={isReviewMode}
                                                onChange={
                                                    !isReviewMode && setAnswer
                                                        ? (e) =>
                                                              setAnswer((prev: any) => ({
                                                                  ...prev,
                                                                  answer: e.target.checked
                                                                      ? prev.answer +
                                                                        (prev.answer.includes(key) ? "" : key)
                                                                      : prev.answer.replace(key, ""),
                                                              }))
                                                        : undefined
                                                }
                                            />
                                            <label className={`form-check-label d-inline-flex align-items-center px-2`} htmlFor={`check_TWO_2_${key}`}>{safeParseHtml(value)}</label>
                                        </div>
                                    )}
                                    </div>
                                </form>
                                <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select two answer choices.</p>
                            </div>
                            :
                            <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                                <p className="py-2 px-0 mb-auto mt-0"></p>
                                <div className="p-2">{safeParseHtml(data.question)}</div>
                                <form className="p-2 d-flex justify-content-center align-items-center">
                                    <div className={`checkbox-container ${showInlineLayout ? 'checkbox-inline' : 'checkbox-stacked'}`}>
                                    {data.answers.R1 && Object.entries(data.answers.R1).map(([key, value]:any) => 
                                        value && <div
                                            className={`choice-item form-check ${showInlineLayout ? 'choice-item-inline form-check-inline' : 'choice-item-stacked'}`}
                                            key={key}
                                        >
                                            <input
                                                className="form-check-input ms-0 gre-checkbox"
                                                name={key}
                                                key={rawAnswer ? `loaded_check_TWO_3_${key}` : `notLoadedYet_check_TWO_3_${key}`}
                                                defaultChecked={rawAnswer.includes(key)}
                                                type="checkbox"
                                                id={`check_TWO_3_${key}`}
                                                disabled={isReviewMode}
                                                onChange={
                                                    !isReviewMode && setAnswer
                                                        ? (e) =>
                                                              setAnswer((prev: any) => ({
                                                                  ...prev,
                                                                  answer: e.target.checked
                                                                      ? prev.answer +
                                                                        (prev.answer.includes(key) ? "" : key)
                                                                      : prev.answer.replace(key, ""),
                                                              }))
                                                        : undefined
                                                }
                                            />
                                            <label className={`form-check-label d-inline-flex align-items-center`} htmlFor={`check_TWO_3_${key}`}>{safeParseHtml(value)}</label>
                                        </div>
                                    )}
                                    </div>
                                </form>
                                <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0"> Select one or more answer choices.</p>
                            </div>
                        );


                    case "TWOCOPARE":
                        return ( 
                            <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                                <p className="py-2 px-0 bg-white mb-auto mt-0"></p>
                                <div className="p-2">{safeParseHtml(data.question)}</div>
                                <div className="row p-2 text-center">
                                    <div className="col-6"><p className="text-decoration-underline mb-0">Quantity A</p>{safeParseHtml(data.answers?.R1?.A)}</div>
                                    <div className="col-6"><p className="text-decoration-underline mb-0">Quantity B</p>{safeParseHtml(data.answers?.R1?.B)}</div>
                                </div>
                                <form className="p-2 w-50 mx-auto text-center">
                                    <div className="form-check form-check-reverse mb-4">
                                        <input
                                            className="form-check-input gre-radio"
                                            name="TWOCOPARE"
                                            key={rawAnswer ? 'loaded_TWOCOPARE_A' : 'notLoadedYet_TWOCOPARE_A'}
                                            defaultChecked={rawAnswer === "A"}
                                            type="radio"
                                            id="TWOCOPARE_a"
                                            disabled={isReviewMode}
                                            onChange={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer: "A",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label  className={`form-check-label px-2`} htmlFor="TWOCOPARE_a">Quantity A is greater.</label>
                                    </div>
                                    <div className="form-check form-check-reverse mb-4">
                                        <input
                                            className="form-check-input gre-radio"
                                            name="TWOCOPARE"
                                            key={rawAnswer ? 'loaded_TWOCOPARE_B' : 'notLoadedYet_TWOCOPARE_B'}
                                            defaultChecked={rawAnswer === "B"}
                                            type="radio"
                                            id="TWOCOPARE_b"
                                            disabled={isReviewMode}
                                            onChange={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer: "B",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label  className={`form-check-label px-2`} htmlFor="TWOCOPARE_b">Quantity B is greater.</label>
                                    </div>
                                    <div className="form-check form-check-reverse mb-4">
                                        <input
                                            className="form-check-input gre-radio"
                                            name="TWOCOPARE"
                                            key={rawAnswer ? 'loaded_TWOCOPARE_C' : 'notLoadedYet_TWOCOPARE_C'}
                                            defaultChecked={rawAnswer === "C"}
                                            type="radio"
                                            id="TWOCOPARE_c"
                                            disabled={isReviewMode}
                                            onChange={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer: "C",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label  className={`form-check-label px-2`} htmlFor="TWOCOPARE_c">The two quantities are equal.</label>
                                    </div>
                                    <div className="form-check form-check-reverse mb-4">
                                        <input
                                            className="form-check-input gre-radio"
                                            name="TWOCOPARE"
                                            key={rawAnswer ? 'loaded_TWOCOPARE_D' : 'notLoadedYet_TWOCOPARE_D'}
                                            defaultChecked={rawAnswer === "D"}
                                            type="radio"
                                            id="TWOCOPARE_d"
                                            disabled={isReviewMode}
                                            onChange={
                                                !isReviewMode && setAnswer
                                                    ? () =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer: "D",
                                                          }))
                                                    : undefined
                                            }
                                        />
                                        <label  className={`form-check-label px-2`} htmlFor="TWOCOPARE_d">The relationship cannot be determined from the information given.</label>
                                    </div>
                                </form>
                                <p className="w-50 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Select one answer choice.</p>
                            </div>
                        );


                    case "ONEINPUT":
                        return ( 
                            <div className="d-flex align-items-middle flex-column col-sm-8 mx-auto my-2 p-0" style={{minHeight:"80vh"}}>
                                <p className="py-2 px-0 bg-white mb-auto mt-0"></p>
                                <div className="p-2">{safeParseHtml(data.question)}</div>
                                <form className="p-2 w-75 mx-auto text-center">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        {data.answer_left_text && (
                                            <div className="panel-chip-ghost pt-3">
                                                {safeParseHtml(data.answer_left_text)}
                                            </div>
                                        )}
                                        <input
                                            type="text"
                                            id="ONEINPUT"
                                            key={rawAnswer ? 'loaded_ONEINPUT' : 'notLoadedYet_ONEINPUT'}
                                            onChange={
                                                !isReviewMode && setAnswer
                                                    ? (e) =>
                                                          setAnswer((prev: any) => ({
                                                              ...prev,
                                                              answer: e.target.value,
                                                          }))
                                                    : undefined
                                            }
                                            defaultValue={rawAnswer}
                                            className="form-control form-control-sm rounded-0 border-2 border-black text-center"
                                            aria-describedby="ONEINPUT QUANT"
                                            style={{ maxWidth: 160 }}
                                            disabled={isReviewMode}
                                        />
                                        {data.answer_right_text && (
                                            <div className="panel-chip-ghost pt-3">
                                                {safeParseHtml(data.answer_right_text)}
                                            </div>
                                        )}
                                    </div>
                                </form>
                                <p className="w-75 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Enter your answer as an integer or a decimal in the answer box. Backspace to erase.</p>
                            </div>
                        );


                    case "FRACINPUT":
                        return ( 
                            <div className="row m-0 p-0" style={{minHeight:"80vh"}}>
                                <div className="col-lg-8 col-xs-12 border border-1 border-secondary p-2">
                                    <div className="p-3 text-center">{safeParseHtml(data.question)}</div>
                                </div>
                                <div className="col-lg-4 col-xs-12 border border-1 border-secondary p-2">
                                    <div className="d-flex align-items-middle flex-column mx-auto my-2 p-0" style={{minHeight:"78vh"}}>
                                        <div className="p-2 text-end">{safeParseHtml(data?.question_extra)}</div>
                                        <form className="p-2 w-75 mx-auto text-center">
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                {data.answer_left_text && (
                                                    <div className="panel-chip-ghost">
                                                        {safeParseHtml(data.answer_left_text)}
                                                    </div>
                                                )}
                                                <div style={{ maxWidth: 160 }}>
                                                    <input
                                                        type="text"
                                                        key={rawAnswer ? 'loaded_FRACINPUT_TOP' : 'notLoadedYet_FRACINPUT_TOP'}
                                                        onChange={
                                                            !isReviewMode && setAnswer
                                                                ? (e) =>
                                                                      setAnswer((prev: any) => ({
                                                                          ...prev,
                                                                          answer:
                                                                              prev.answer.split('/')[1] === undefined
                                                                                  ? e.target.value
                                                                                  : e.target.value +
                                                                                    '/' +
                                                                                    prev.answer.split('/')[1],
                                                                      }))
                                                                : undefined
                                                        }
                                                        defaultValue={rawAnswer.split('/')[0]}
                                                        onKeyDown={(e) => handleKeyDown(e)}
                                                        className="form-control form-control-sm rounded-0 border-1 border-black text-center"
                                                        aria-describedby="FRACINPUT QUANT"
                                                        disabled={isReviewMode}
                                                    />
                                                    <hr />
                                                    <input
                                                        type="text"
                                                        key={rawAnswer ? 'loaded_FRACINPUT_BOTTOM' : 'notLoadedYet_FRACINPUT_BOTTOM'}
                                                        onChange={
                                                            !isReviewMode && setAnswer
                                                                ? (e) =>
                                                                      setAnswer((prev: any) => ({
                                                                          ...prev,
                                                                          answer: !prev.answer.includes('/')
                                                                              ? prev.answer + '/' + e.target.value
                                                                              : prev.answer.split('/')[0] +
                                                                                '/' +
                                                                                e.target.value,
                                                                      }))
                                                                : undefined
                                                        }
                                                        defaultValue={rawAnswer.split('/')[1]}
                                                        className="form-control form-control-sm rounded-0 border-1 border-black text-center"
                                                        aria-describedby="FRACINPUT QUANT2"
                                                        disabled={isReviewMode}
                                                    />
                                                </div>
                                                {data.answer_right_text && (
                                                    <div className="panel-chip-ghost">
                                                        {safeParseHtml(data.answer_right_text)}
                                                    </div>
                                                )}
                                            </div>
                                        </form>
                                        <p className="w-100 mx-auto mt-auto p-2 bg-secondary-subtle mb-0">Enter your answer as a fraction, with the numerator and denominator in their respective answer boxes. Backspace to erase.</p>
                                    </div>
                                </div>
                            </div>
                        );


                    case "WRITING":
                        return ( 
                            <div className="row m-0 p-0" style={{minHeight:"80vh"}}>
                                <div className="col-lg-4 col-xs-12 border border-1 border-secondary p-0">
                                    <div className="p-2 pb-0 text-end border border-1 border-secondary">{safeParseHtml(data.question)}</div>
                                    {data.question_extra && <div className="p-3 text-end">{safeParseHtml(data?.question_extra)}</div>}
                                </div>
                                <div className="col-lg-8 col-xs-12 border border-1 border-secondary p-0">
                                    <div className="d-flex align-items-middle flex-column mx-auto p-0" style={{minHeight:"78vh"}}>
                                        <form className="w-100 mx-auto text-center">
                                            <TextAreaControls targetId="WRITING"/>
                                            <textarea
                                                className="form-control rounded-0"
                                                id="WRITING"
                                                rows={26}
                                                spellCheck={false}
                                                autoCorrect="off"
                                                autoCapitalize="off"
                                                onChange={
                                                    !isReviewMode && setAnswer
                                                        ? (e) =>
                                                              setAnswer((prev: any) => ({
                                                                  ...prev,
                                                                  answer: e.target.value,
                                                              }))
                                                        : undefined
                                                }
                                                key={rawAnswer ? "loaded" : "notLoadedYet"}
                                                defaultValue={rawAnswer}
                                                disabled={isReviewMode}
                                            ></textarea>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        );
        
            default:
                return <>{safeParseHtml(data.question)}</>;
        }
    }
    else return <>Not Found</>
}

export default Question;
